import React, { useState, useEffect } from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { useForm } from "react-hook-form";
import { BtnPrimary } from "../../share/buttons/Btn";
import DatePickerInput from "../../share/input/DatePicker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import goast from "../../../Assets/Image/png/goast.png";
import useFetch from "../../../Hooks/useFetch";
import moment from "jalali-moment";

function AdminIdeaModalCourse({
    close,
    submitIdeaStatus,
    setSubmitIdeaStatus,
    show,
    setShow,
    getIdeasService,
    setIdea,
    edit,
    setEdit,
}) {
    const [start, setStart] = useState("");
    const [end, setEnd] = useState("");
    const [call, setCall] = useState();

    const [ideaService, setIdeaService] = useState({
        id: "",
        idea_start_time: "",
        idea_end_time: "",
    });

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    const newIdeaService = useFetch({
        method: "POST",
        url: `BootCampIdeasService`,
        noHeader: false,
        caller: getIdeasService,
        trigger: false,
        data: call,
    });

    const getIdeaServiceId = useFetch({
        method: "GET",
        url: `BootCampIdeasService/${edit}`,
        noHeader: false,
        setter: setIdeaService,
    });

    const editIdeaService = useFetch({
        method: "PATCH",
        url: `BootCampIdeasService/${edit}`,
        noHeader: false,
        caller: getIdeasService,
        data: ideaService,
    });

    const onSubmit = () => {
        if (edit) {
            editIdeaService.reFetch();

            // if (!editTicket.loading) {
            //     setTicket({
            //         id: "",
            //         ticket_number: 0,
            //         ticket_name: "",
            //         ticket_price: "",
            //         ticket_start_time: "",
            //         ticket_end_time: "",
            //     });
            //     setStart("");
            //     setEnd("");
            //     console.log("reset");
            // }
            //TODO : pak kardane modal bad az patch

            close();
        } else {
            const formData = new FormData();

            formData.append("bootcamp", 11);
            //TODO : id bootcamp dynamic she
            formData.append("idea_start_time", ideaService.idea_start_time);
            formData.append("idea_end_time", ideaService.idea_end_time);

            setCall(formData);
            newIdeaService.reFetch();

            setIdeaService({
                id: "",
                idea_start_time: "",
                idea_end_time: "",
            });

            setStart("");
            setEnd("");

            setSubmitIdeaStatus(true);
            setShow(true);

            close();
        }
    };

    useEffect(() => {
        setIdeaService({
            ...ideaService,
            idea_start_time: moment(start, "HH:mm:ss jYYYY/jMM/jDD").format(),
        });
    }, [start]);
    useEffect(() => {
        setIdeaService({
            ...ideaService,
            idea_end_time: moment(end, "HH:mm:ss jYYYY/jMM/jDD").format(),
        });
    }, [end]);

    useEffect(() => {
        if (edit) {
            getIdeaServiceId.reFetch();
        }
    }, [edit]);

    useEffect(() => {
        if (edit) {
            setStart(
                moment(ideaService.idea_start_time)
                    .locale("fa", { useGregorianParser: true })
                    .format("HH:mm:ss YYYY/MM/DD")
            );

            setEnd(
                moment(ideaService.idea_end_time)
                    .locale("fa", { useGregorianParser: true })
                    .format("HH:mm:ss YYYY/MM/DD")
            );
        }
    }, [ideaService]);

    return (
        <div className="AddnewsupportTicket relative">
            <button
                onClick={() => close(false)}
                className="AddnewsupportTicket-cancel absolute  "
            >
                <div>
                    <Cancel />
                </div>
            </button>
            {submitIdeaStatus === false ? (
                <>
                    <h3 className=" text-center text-[#77498F] text-[16px] mb-16">
                        اطلاعات زمانی ثبت ایده
                    </h3>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className=" mb-[2rem]">
                            <DatePickerInput
                                register={{
                                    required: true,
                                }}
                                setDate={setStart}
                                defaultValue={start}
                                message="زمان شروع ثبت ایده"
                                placeholder="زمان شروع ثبت ایده *"
                                name="catch_end_date"
                                full={true}
                                control={control}
                                plugins={[<TimePicker position="bottom" />]}
                            />
                        </div>
                        <DatePickerInput
                            register={{
                                required: true,
                            }}
                            setDate={setEnd}
                            defaultValue={end}
                            message="زمان پایان ثبت ایده"
                            placeholder="زمان پایان ثبت ایده *"
                            name="catch_end_date"
                            full={true}
                            control={control}
                            plugins={[<TimePicker position="bottom" />]}
                        />
                        <div className=" text-left mt-[3rem]">
                            <BtnPrimary
                                className="py-[20px] px-[25px] "
                                text="ثبت زمان"
                                type={"submit"}
                                htmlType="submit"
                            />
                        </div>
                    </form>
                </>
            ) : (
                <div>
                    <img
                        src={goast}
                        alt="goast"
                        className=" max-w-[11.582rem] max-h-[9.465rem] text-center mx-auto"
                    />
                    <p className=" mt-[1.7rem] text-[#212121E5] font-medium text-[2.4rem] leading-[4.8rem] text-center mx-auto">
                        ثبت ایده فعال شد!
                    </p>
                    <p className=" text-[#212121E5] font-normal text-[1.8rem] leading-[3.2rem] text-center mx-auto mt-[0.8rem]">
                        افراد بوت کمپ میتوانند از بخش ثبت ایده، ایده های خود را
                        ثبت کنند.
                    </p>
                    <div className=" text-center mt-[3rem]">
                        <BtnPrimary
                            className="py-[20px] px-[25px] "
                            text="متوجه شدم"
                            onClick={() => {
                                //setIdea(true);
                                close(false);
                            }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

export default AdminIdeaModalCourse;
